export const GRID_WIDTH = 15;
export const GRID_HEIGHT = 21;
export const CELL_SIZE = 32;

export const PLAYER_TWEEN_DURATION = 200; // ms per tile
export const REMNANT_TWEEN_DURATION = 200; // ms per tile (same speed as player)
export const REMNANT_RECALC_INTERVAL = 15; // frames between A* recalcs
export const REMNANT_COUNT = 3;

export const COOLDOWN_DURATION = 2000; // ms between player wall toggles
export const AI_COOLDOWN_DURATION = 4000; // ms between AI wall toggles
export const VISION_RADIUS = 4; // tiles the player can see Remnants

export const SCORE_PER_SECOND = 10;
export const SCORE_EXIT_BONUS = 500;
export const MAX_LEVEL = 10;

/** Get level-adjusted values. Level 1 = base, level 10 = hardest. */
export function getLevelConfig(level: number) {
  const t = (Math.min(level, MAX_LEVEL) - 1) / (MAX_LEVEL - 1); // 0..1
  return {
    remnantTweenDuration: Math.round(400 - t * 300),   // 400 → 100
    playerCooldown: Math.round(2000 + t * 2000),       // 2000 → 4000
    aiCooldown: Math.round(4000 - t * 2000),            // 4000 → 2000
  };
}

export const COLORS = {
  BACKGROUND: 0x1a1a2e,
  WALL: 0xe0e0e0,
  WALL_HOVER_REMOVE: 0xff4444,
  WALL_HOVER_ADD: 0x44ff44,
  WALL_HOVER_DISABLED: 0x888888,
  PLAYER: 0x00aaff,
  REMNANT: 0xff4444,
  EXIT: 0x44ff44,
  COOLDOWN_READY: 0x00aaff,
  COOLDOWN_ACTIVE: 0x66ccff,
  AI_COOLDOWN_READY: 0xff4444,
  AI_COOLDOWN_ACTIVE: 0xff8888,
  TEXT: 0xffffff,
};

export const WALL_THICKNESS = 4;

export const LEFT_PANEL_WIDTH = 80;
export const RIGHT_PANEL_WIDTH = 80;
export const TOP_PANEL_HEIGHT = 27;
export const BOTTOM_PANEL_HEIGHT = 16;
export const PANEL_COLOR = 0x1a1a2e;

/** Canvas dimensions derived from grid */
export const MAZE_WIDTH = GRID_WIDTH * CELL_SIZE;
export const MAZE_HEIGHT = GRID_HEIGHT * CELL_SIZE;
export const CANVAS_WIDTH = LEFT_PANEL_WIDTH + MAZE_WIDTH + RIGHT_PANEL_WIDTH;
export const CANVAS_HEIGHT = TOP_PANEL_HEIGHT + MAZE_HEIGHT + BOTTOM_PANEL_HEIGHT;
